export default "__VITE_ASSET__55hKVE7e__"